import React from 'react';
import { usePage } from "@inertiajs/inertia-react";
import { Background } from "react-imgix";
import { Drawer } from "./Drawer";

export const ReadDrawer = ({activeTab, setActiveTab, praiseReports, dgi}) => {
    const {imgixURL} = usePage().props;

    return (
        <Drawer drawerId='read' activeTab={activeTab} setActiveTab={setActiveTab}>
            {dgi ? (
                <a
                    href={'/blog/daily-grace-inspirations/' + dgi.slug}
                    className='card card-compact w-full bg-base-100 shadow-xl image-full mb-2'
                >
                    <Background
                        className='h-full bg-center'
                        src={`https://${imgixURL}/${dgi.thumbnail}`}
                        imgixParams={{auto: 'format', fit: 'crop'}}
                        sizes='(min-width: 1280px) 454p, (min-width: 1024px) 262px, (min-width: 768px) 100vw, (min-width: 640px) 100vw, 100vw'
                    />
                    <div className='card-body'>
            <span className='text-xs font-medium text-left text-white uppercase tracking-widest'>
              Daily Grace Inspirations
            </span>
                        <h2 className='card-title text-white'>{dgi.title}</h2>
                        {/* <p className="text-white">{item.description}</p> */}
                        <div className='card-actions justify-start'>
                            <button className='btn-sm btn-secondary rounded'>Read More</button>
                        </div>
                    </div>
                </a>
            ) : (
                ''
            )}
            {praiseReports &&
                praiseReports.map((item, index) => (
                    <a
                        href={'/blog/praise-reports/' + item.slug}
                        className='card card-compact w-full bg-base-100 shadow-xl image-full mb-2'
                        key={index}
                    >
                        <Background
                            className='h-full bg-center'
                            src={`https://${imgixURL}/${item.image}`}
                            imgixParams={{auto: 'format', fit: 'crop'}}
                            sizes='(min-width: 1280px) 454p, (min-width: 1024px) 262px, (min-width: 768px) 100vw, (min-width: 640px) 100vw, 100vw'
                        />
                        <div className='card-body'>
              <span className='text-xs font-medium text-left text-white uppercase tracking-widest'>
                Praise Report
              </span>
                            <h2 className='card-title text-white'>{item.title}</h2>
                            {/* <p className="text-white">{item.description}</p> */}
                            <div className='card-actions justify-start'>
                                <button className='btn-sm btn-secondary rounded'>Read More</button>
                            </div>
                        </div>
                    </a>
                ))}
        </Drawer>
    );
};